var render, staticRenderFns
import script from "./Header.vue?vue&type=script&lang=tsx&"
export * from "./Header.vue?vue&type=script&lang=tsx&"
import style0 from "./Header.vue?vue&type=style&index=0&id=f13be314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13be314",
  null
  
)

export default component.exports